require("es6-promise").polyfill();
require("isomorphic-fetch");

export let getPaymentRequestJson = (formData, card_data) => {
  const card_holder_identification = { type: "", number: "" };
  const newCardData = { ...card_data.cardData, card_holder_identification };
  let data = {
    hash: formData.hash,
    formId: formData.formId,
    site_transaction_id: formData.siteTransactionId,
    redirect_url: formData.redirectUrl,
    device_unique_identifier: formData.deviceUniqueIdentifier,
    card_data: newCardData,
  };
  if (
    typeof formData.auth_3DS !== "undefined" &&
    formData.auth_3DS &&
    Object.keys(formData.auth_3DS).length !== 0
  ) {
    data.auth_3ds_data = formData.auth_3DS;
  }

  return data;
};

export let getOfflinePaymentRequestJson = (
  formData,
  paymentData,
  offlineFormData
) => {
  return {
    hash: formData.hash,
    formId: formData.formId,
    site_transaction_id: formData.siteTransactionId,
    redirect_url: formData.redirectUrl,
    paymentMethodId: paymentData.paymentMethod,
    fullName: offlineFormData.fullName,
    documentType: offlineFormData.documentType,
    email: offlineFormData.email,
    bank_id: offlineFormData.bank,
    documentNumber: offlineFormData.documentNumber,
  };
};

export let doPaymentRequest = (body, props, screen) => {
  /**
   * Si es un form con apikey, la url actual es /forms/<hash> y la url de pago /forms/<hash>/payments,
   * pero si no tiene apikey, la url actual es /form?hash=<hash> y la url de pago es /payments
   */
  const securedForm = !props.queryString.hash;
  const paymentUrl = securedForm
    ? `${window.location.pathname}/payments`
    : "payments";
  const instructionUrl = securedForm
    ? `${window.location.pathname}/threeds/instruction`
    : "threeds/instruction";
  let headers = {};
  const paymentSuccessAction = props.actions.paymentSuccess;

  if (`${process.env.NODE_ENV}` === "development") {
    headers = {
      "Content-Type": "application/json",
      "X-Consumer-Username": props.formData.consumerUsername,
    };
  } else {
    headers = {
      "Content-Type": "application/json",
      apikey: props.queryString.apikey,
    };
  }

  fetch(paymentUrl, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(body),
  })
    .then((response) => validateResponse(response))
    .then((response) => mapFingerprintResponse(response))
    .then((paymentResponse) => {
      if (paymentResponse.redirect)
        window.location = paymentResponse.redirectUrl;
      else paymentSuccessAction(paymentResponse, screen);
    });
  props.actions.startPayment();

  function asJson(text) {
    try {
      return JSON.parse(text);
    } catch (e) {
      return unknownError;
    }
  }

  let timeOutError = {
    success: false,
    error: {
      message: "Tiempo de espera agotado.",
      timeout: true,
    },
  };
  let unknownError = {
    success: false,
    error: {
      message: "Error al obtener respuesta del servidor.",
      timeout: false,
    },
  };

  let processInstructionError = {
    success: false,
    error: {
      message: "Error al procesar la autenticación del pago.",
      timeout: false,
    },
  };

  function validateResponse(response) {
    if (!response.ok) {
      if (response.status === 504) return timeOutError;
      return unknownError;
    }
    return response.text().then((response) => asJson(response));
  }

  async function mapFingerprintResponse(paymentResponse) {
    if (!isFingerprint(paymentResponse)) return paymentResponse;
    return await resolveInstruction(paymentResponse);
  }

  function isFingerprint(paymentResponse) {
    return "FINGERPRINT PENDING" === paymentResponse.status;
  }

  async function resolveInstruction(paymentResponse, retries = 1) {
    callThreedsScript(paymentResponse);
    return await sendInstructionData(paymentResponse, retries);
  }

  function sendTimeoutMessage(instructionResponse, retries) {
    if (instructionResponse.timeout) {
      setTimeout(() => {
        const instructionResultTimeout = {
          eventName: "AUTH_INSTRUCTION_TIMEOUT",
          retries,
        };
        window.postMessage(JSON.stringify(instructionResultTimeout), "*");
      }, instructionResponse.timeout * 1000);
    }
  }

  async function sendInstructionData(paymentResponse, retries) {
    sendTimeoutMessage(paymentResponse, retries);
    return await waitForMessage()
      .then(async (event) => {
        try {
          let instructionData = JSON.parse(event.data);
          let requestBody = {
            id: paymentResponse.id,
            instruction_value: instructionData.value.value,
            hash: body.hash,
            site_transaction_id: body.site_transaction_id,
            formId: body.formId,
            payment_method_id: body.card_data.payment_method_id,
            redirect_url: body.redirect_url,
          };
          return await fetch(instructionUrl, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(requestBody),
          }).then(async (paymentResponse) => {
            return validateResponse(paymentResponse);
          });
        } catch (err) {
          return processInstructionError;
        }
      })
      .catch((e) => {
        if (e.message.endsWith("Reintentar"))
          resolveInstruction(paymentResponse, 0);
        return processInstructionError;
      });
  }

  function waitForMessage() {
    return new Promise((resolve, reject) => {
      window.addEventListener("message", function listener(event) {
        if (JSON.parse(event.data).eventName === "AUTH_INSTRUCTION_TIMEOUT") {
          if (JSON.parse(event.data).retries === 0) {
            reject(new Error("Tiempo de espera agotado."));
          }
          reject(new Error("Tiempo de espera agotado. Reintentar"));
        }
        resolve(event);
      });
    });
  }

  function callThreedsScript(paymentResponse) {
    let mainContainer = document.getElementById("root");
    let instructionContainer = document.createElement("div");
    instructionContainer.setAttribute("id", "threedsContainer");
    mainContainer.appendChild(instructionContainer);

    instructionContainer.innerHTML = "";

    let iframe = document.createElement("iframe");
    iframe.id = "instructionIframe";
    iframe.name = "instructionIframe";
    iframe.src = "about:blank";
    iframe.style.visibility = paymentResponse.target.visible
      ? "visible"
      : "hidden";

    instructionContainer.appendChild(iframe);

    let instructionForm = document.createElement("form");
    instructionForm.id = "instructionForm";
    instructionForm.name = "instructionForm";
    instructionForm.target = "instructionIframe";
    instructionForm.method = paymentResponse.http.method;
    instructionForm.action = paymentResponse.http.url;
    instructionForm.style = "visibility: hidden";

    let parsedBody = JSON.parse(paymentResponse.http.body);

    Object.keys(parsedBody).forEach(function(name) {
      instructionForm.innerHTML +=
        '<input name="' + name + '" value="' + parsedBody[name] + '">';
    });
    instructionContainer.appendChild(instructionForm);
    instructionForm.submit();
  }
};
